let moment: any = {};
try {
  moment = require('moment');
} catch (err) {}

export default moment;
